module.exports = __webpack_public_path__ + "static/media/frown.c15f67a0.svg";